import { Box } from "@itandi/itandi-bb-ui/Box";
import { Flex } from "@itandi/itandi-bb-ui/Flex";
import { FormControl } from "@itandi/itandi-bb-ui/FormControl";
import { InputRadio } from "@itandi/itandi-bb-ui/InputRadio";
import React from "react";
import { useDealConstructionItems } from "~/hooks/useDealConstructionItems";
import { useUsingApplications } from "~/hooks/useUsingApplications";
import type { NskResponse } from "~/models/Api";
import type { DealConstructionEdit } from "~/models/DealConstruction";
import type { DealSettlementEdit } from "~/models/DealSettlement";
import { SettlementAddForm } from "../../settlements/adding/SettlementAddForm";
import { ConstructionAddForm } from "./ConstructionAddForm";
import Styles from "./InvoiceItemAddForm.module.scss";

type Props = {
	billingType: "owner" | "rentee";
	handleCreate: (
		submitValue: DealConstructionEdit | DealSettlementEdit
	) => Promise<NskResponse>;
	mutateConstructions: () => Promise<void>;
};
export const InvoiceItemAddForm: React.FC<Props> = ({
	billingType,
	handleCreate,
	mutateConstructions
}: Props) => {
	const [selectedOption, setSelectedOption] = React.useState("construction");
	const { useSK } = useUsingApplications();
	const { data: dealConstructionItems } = useDealConstructionItems();
	if (dealConstructionItems === null) return null;
	return (
		<div className={Styles.EstimateAddForm}>
			{!useSK && (
				<Box margin="8px">
					<FormControl chip="必須" label="項目選択" variant="vertical">
						<Flex gap="16px">
							<InputRadio
								checked={selectedOption === "construction"}
								label="施工項目"
								onChange={(): void => {
									setSelectedOption("construction");
								}}
								value="construction"
							/>
							<InputRadio
								checked={selectedOption === "settlement"}
								label="精算項目"
								onChange={(): void => {
									setSelectedOption("settlement");
								}}
								value="settlement"
							/>
						</Flex>
					</FormControl>
				</Box>
			)}
			{selectedOption === "construction" ? (
				<ConstructionAddForm
					dealConstructionItems={dealConstructionItems}
					handleCreate={handleCreate}
					mutateConstructions={mutateConstructions}
				/>
			) : (
				<SettlementAddForm
					billingType={billingType}
					handleCreate={handleCreate}
					mutateConstructions={mutateConstructions}
				/>
			)}
		</div>
	);
};
